import React from "react";

const DiscoverSmallIcon = () => {
  return (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Discover"
    >
      <g clipPath="url(#clip0_3818_267)">
        <path
          d="M23.2096 0H0.790427C0.353057 0 0 0.368006 0 0.823893V15.1761C0 15.632 0.353057 16 0.790427 16H23.2096C23.6469 16 24 15.632 24 15.1761V0.823893C24 0.368006 23.6469 0 23.2096 0ZM22.8196 8C22.8196 12.265 19.5025 15.7254 15.4081 15.7254H0.790427C0.75354 15.7254 0.719289 15.7226 0.685037 15.7144C0.650785 15.7061 0.616533 15.6952 0.584916 15.6814C0.540125 15.6622 0.497969 15.632 0.461082 15.599C0.434735 15.5771 0.411022 15.5524 0.389944 15.5249C0.313536 15.4288 0.263476 15.3079 0.263476 15.1734V0.823893C0.263476 0.711294 0.297728 0.604188 0.353057 0.516306C0.371501 0.486097 0.392579 0.458634 0.416292 0.433917C0.463717 0.384483 0.521682 0.343289 0.584916 0.315826C0.616533 0.302094 0.650785 0.291109 0.685037 0.28287C0.719289 0.274631 0.75354 0.271885 0.790427 0.271885H15.4081C19.4998 0.271885 22.8196 3.72949 22.8196 7.99725V8Z"
          fill="url(#paint0_linear_3818_267)"
        />
        <path
          d="M2.04452 6.1687H1.11182V9.28531H2.04189C2.53459 9.28531 2.89291 9.17454 3.20645 8.92531C3.57795 8.63077 3.79927 8.1877 3.79927 7.72952C3.79927 6.81065 3.07998 6.1687 2.04716 6.1687H2.04452ZM2.78752 8.50993C2.58728 8.68112 2.32907 8.75664 1.91805 8.75664H1.74679V6.69485H1.91805C2.32907 6.69485 2.57938 6.76534 2.78752 6.94659C3.00884 7.13288 3.14058 7.42491 3.14058 7.72197C3.14058 8.01903 3.00884 8.32112 2.78752 8.50741V8.50993Z"
          fill="#261F20"
        />
        <path
          d="M4.72409 6.1687H4.08911V9.28531H4.72409V6.1687Z"
          fill="#261F20"
        />
        <path
          d="M6.28125 7.36449C5.89921 7.22854 5.78855 7.14043 5.78855 6.97176C5.78855 6.7754 5.98879 6.62687 6.2628 6.62687C6.4525 6.62687 6.61059 6.7024 6.77658 6.87862L7.10856 6.46324C6.83454 6.23415 6.50783 6.11835 6.14951 6.11835C5.5725 6.11835 5.13249 6.501 5.13249 7.01204C5.13249 7.44253 5.338 7.66154 5.93609 7.86546C6.18376 7.94853 6.31286 8.00644 6.3761 8.04168C6.50257 8.11972 6.5658 8.23301 6.5658 8.36391C6.5658 8.61566 6.35502 8.80447 6.07047 8.80447C5.76747 8.80447 5.52244 8.65845 5.37489 8.38909L4.96387 8.76671C5.25633 9.17705 5.60938 9.36082 6.09418 9.36082C6.7555 9.36082 7.21922 8.94041 7.21922 8.33874C7.21922 7.8428 7.0058 7.61875 6.28125 7.367V7.36449Z"
          fill="#261F20"
        />
        <path
          d="M7.41943 7.7295C7.41943 8.64585 8.17297 9.35577 9.13993 9.35577C9.41394 9.35577 9.64844 9.30542 9.93826 9.17452V8.45956C9.68269 8.70375 9.45874 8.80193 9.16891 8.80193C8.52867 8.80193 8.07285 8.35886 8.07285 7.72698C8.07285 7.12783 8.54184 6.65706 9.13993 6.65706C9.44293 6.65706 9.67215 6.76028 9.93826 7.00699V6.29203C9.65898 6.15609 9.42975 6.10071 9.15574 6.10071C8.19142 6.10071 7.41943 6.82573 7.41943 7.73202V7.7295Z"
          fill="#261F20"
        />
        <path
          d="M14.9837 8.2607L14.1116 6.1687H13.4187L14.8019 9.36335H15.1445L16.5541 6.1687H15.8638L14.9837 8.2607Z"
          fill="#261F20"
        />
        <path
          d="M16.8413 9.28531H18.6461V8.75664H17.4763V7.91581H18.6013V7.38715H17.4763V6.69737H18.6461V6.1687H16.8413V9.28531Z"
          fill="#261F20"
        />
        <path
          d="M21.1649 7.08757C21.1649 6.50352 20.7433 6.1687 20.0109 6.1687H19.0676V9.28531H19.7026V8.03413H19.7869L20.6669 9.28531H21.4494L20.4219 7.9712C20.9014 7.87805 21.1649 7.56589 21.1649 7.08757ZM19.8897 7.60113H19.7026V6.65709H19.8976C20.2928 6.65709 20.5088 6.81569 20.5088 7.1203C20.5088 7.42491 20.2928 7.60113 19.887 7.60113H19.8897Z"
          fill="#261F20"
        />
        <path
          d="M21.6708 6.3323C21.6708 6.27691 21.6313 6.2467 21.5628 6.2467H21.4706V6.52111H21.5391V6.41537L21.6208 6.52111H21.7051L21.6102 6.40782C21.6497 6.39775 21.6735 6.37006 21.6735 6.3323H21.6708ZM21.5496 6.37006H21.5391V6.29705H21.5523C21.5865 6.29705 21.605 6.30964 21.605 6.3323C21.605 6.35495 21.5865 6.37006 21.5523 6.37006H21.5496Z"
          fill="#261F20"
        />
        <path
          d="M21.576 6.14349C21.4363 6.14349 21.3257 6.24923 21.3257 6.38265C21.3257 6.51608 21.439 6.62181 21.576 6.62181C21.713 6.62181 21.8237 6.51356 21.8237 6.38265C21.8237 6.25174 21.713 6.14349 21.576 6.14349ZM21.576 6.57901C21.4653 6.57901 21.3757 6.4909 21.3757 6.38265C21.3757 6.2744 21.4653 6.18629 21.576 6.18629C21.6866 6.18629 21.7736 6.27692 21.7736 6.38265C21.7736 6.48838 21.684 6.57901 21.576 6.57901Z"
          fill="#261F20"
        />
        <g filter="url(#filter0_i_3818_267)">
          <circle
            cx="11.8334"
            cy="7.75171"
            r="1.76605"
            fill="url(#paint1_linear_3818_267)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_3818_267"
          x="10.0674"
          y="5.98566"
          width="3.7921"
          height="3.7921"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.01"
            operator="erode"
            in="SourceAlpha"
            result="effect1_innerShadow_3818_267"
          />
          <feOffset dx="0.5" dy="0.5" />
          <feGaussianBlur stdDeviation="0.125" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3818_267"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3818_267"
          x1="31.9991"
          y1="44.1909"
          x2="3.48371"
          y2="-3.30507"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9A020" />
          <stop offset="0.5" stopColor="#F9A020" />
          <stop offset="1" stopColor="#DF5026" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3818_267"
          x1="13.2656"
          y1="8.85284"
          x2="10.6562"
          y2="6.41534"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EA953E" />
          <stop offset="1" stopColor="#D44B33" />
        </linearGradient>
        <clipPath id="clip0_3818_267">
          <rect width="24" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DiscoverSmallIcon;
